export default import.meta.ROLLUP_FILE_URL_2d99dc05;